import React from "react";

const Subtitle = ({ children }) => (children ? <h6>{children}</h6> : null);

export default Subtitle;
